export function zipcodeValidator (value, field, model) {
    console.log('model', field, model)
    const re = /(^\d{5}$)|(^\d{5}-\d{4}$)/

    if (!re.test(value)) {
        return ['Invalid Zip Code.']
    } else {
        return []
    }
}

export function confirmEqualValidator (value, field, model) {
    return value === model[field.confirmField.field] ? [] : [field.confirmField.message || 'Field confirmation is invalid.']
}

export function validatePassword (value) {
    let regex = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{8,}$/
    if (value) {
      if (!regex.test(value)) {
        return ['Password must have 8 characters, at least one letter, one number.']
      } else {
          return [];
      }
    }
}




// WEBPACK FOOTER //
// ./src/lib/utils/validators.js